import { render, staticRenderFns } from "./FactorsList.vue?vue&type=template&id=018eeef0&scoped=true"
import script from "./FactorsList.vue?vue&type=script&lang=js"
export * from "./FactorsList.vue?vue&type=script&lang=js"
import style0 from "./FactorsList.vue?vue&type=style&index=0&id=018eeef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018eeef0",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QBanner,QIcon,QBtn,QToggle});qInstall(component, 'directives', {ClosePopup});
